module.exports = __webpack_public_path__ + "5830d198b7d323633138c50439ca957d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-1.png
// module id = 1725
// module chunks = 0